const variables = {
  assetsPrefix: 'https://hodl-assets.fly.dev/s',
  apiHost: 'https://api.hodldash.io',
  colors: {
    background: 'rgb(0, 3, 22)',
    black: 'rgb(0, 3, 23)',
    blue: 'rgb(0, 152, 255)',
    chatPurple: '#0C0F25',
    grey: 'rgb(133, 134, 143)',
    green: '#50E89D',
    marineBlue: 'rgb(17, 19, 49)',
    purple: 'rgb(36, 41, 107)',
    purpleOpac: 'rgba(36, 41, 107, 0)',
    red: '#E85050',
    white: 'rgb(237, 237, 237)',
    yellow: 'rgb(254, 212, 7)'
  },
  desktop: {
    backgroundsMediaQuery: '@media screen and (min-width: 1670px)',
    mediaQuery: '@media screen and (min-width: 901px)',
    device: {
      minWidth: '901px'
    },
    header: {
      width: '1630px'
    },
    body: {
      minWidth: '1420px'
    }
  },
  fonts: {
    default: 'Jost, Helvetica Neue, Arial, sans-serif'
  },
  scaled: {
    backgroundsMediaQuery: '@media screen and (min-width: 901px) and (max-width: 1669px)'
  },
  mobile: {
    backgroundsMediaQuery: '@media screen and (max-width: 900px)',
    mediaQuery: '@media screen and (max-width: 900px)',
    device: {
      maxWidth: '900px'
    }
  },
  mobileWidth: 900,
  scaleWidth: 1670,
  additionalBnbPaidOut: 20353.69605,
  bnbPerNft: 0.2,
  estInvestmentFunds: 0,
  legalLinks: [
    {
      url: '/terms',
      label: 'Terms'
    },
    {
      url: '/privacy',
      label: 'Privacy'
    },
    {
      url: '/cookies',
      label: 'Cookies'
    },
    {
      url: '/disclaimers',
      label: 'Disclaimers'
    }
  ],
  links: {
    abouthodlhands: 'https://hodltoken.net/hodl-hands-nfts',
    abouthodl: 'https://hodltoken.net/about-our-token',
    achievements: 'https://hodltoken.net/achievements',
    announcementsontg: 'https://t.me/HodlAnnouncements',
    appsecurity: 'https://hodltoken.net/app#security',
    artpack: 'https://hodl-assets.fly.dev/s/49b77a14-98b7-4d7d-a62b-331e5e048ad4',
    audit: 'https://github.com/cyberscope-io/audits/blob/main/hodl/audit.pdf',
    binancesquare: 'https://www.binance.com/en/square/profile/hodl_official',
    bugbounty: 'https://hodltoken.net/bug-bounty',
    buy: 'https://pancakeswap.finance/swap?outputCurrency=0x32b407ee915432be6d3f168bc1eff2a6f8b2034c',
    calculator: 'https://hodltoken.net/#calculator',
    claimrewards: 'https://hodltoken.net/claim',
    coingecko: 'https://coingecko.com/en/coins/hodl',
    coinmarketcap: 'https://coinmarketcap.com/currencies/hodl',
    communityguidelines: 'https://hodltoken.net/community-guidelines',
    contract: 'https://bscscan.com/token/0x32b407ee915432be6d3f168bc1eff2a6f8b2034c',
    dappbay: 'https://dappbay.bnbchain.org/detail/hodl',
    dashboardOverview: '/dashboard',
    dashboardRewards: '/dashboard/rewards',
    dashboardReflections: '/dashboard/reflections',
    dashboardReinvestments: '/dashboard/reinvestments',
    dashboardTransactions: '/dashboard/transactions',
    dashboardHolders: '/dashboard/hodlers',
    dashboardAddresses: '/dashboard/addresses',
    dashboardVideo: 'https://www.youtube.com/watch?v=9jFVbA5nkWM',
    dextools: 'https://www.dextools.io/app/bsc/pair-explorer/0xC5c4F99423DfD4D2b73D863aEe50750468e45C19',
    discord: 'https://discord.com/invite/D666jh5C5D',
    downloadandroidapp: 'https://hodltoken.net/android-app',
    downloadappleapp: 'https://hodltoken.net/apple-app',
    elementnftmarket: 'https://www.element.market/collections/hodl-hands-nfts',
    facebook: 'https://facebook.com/HODLtokenBSC',
    gemfighter: 'https://hodltoken.net/gem-fighter-p2e',
    gemfighteronepicgames: 'https://store.epicgames.com/en-US/p/gem-fighter-c706ec',
    gemfighterbeta: 'https://gemfighter.game/gem-fighter-for-windows',
    gemfighterbetamac: 'https://gemfighter.game/gem-fighter-for-mac',
    gemfightercontract: 'https://bscscan.com/address/0x1dc59c50d21514895a88d10f17af8fb1017e6a37#code',
    GemFighterLeaderboard: 'https://gemfighter.game/leaderboard',
    gemfighternfttradeins: 'https://hodlx.exchange/nft-pools',
    gemfighternftsmagiceden: 'https://magiceden.io/collections/bsc/0x1dc59c50d21514895a88d10f17af8fb1017e6a37',
    gemfighternftselement: 'https://element.market/collections/gem-fighter-nfts',
    gemfightervideos: 'https://www.youtube.com/watch?v=TIw8FZNK1HM&list=PLh50Cy8l4VJICLQUFvDEl4M3NzwGpY09J&index=1',
    gemfighteronx: 'https://x.com/GemFighterNFTs',
    gemfighterx: 'https://x.com/GemFighterP2E',
    GemFighterTrailer: 'https://hodltoken.net/videos/gem-fighter-cinematic-story-trailer',
    gemfighterwebsite: 'https://gemfighter.game',
    gemfighterwebsitenfts: 'https://gemfighter.game/nfts',
    gfmarketplace: 'https://magiceden.io/collections/bsc/0x1dc59c50d21514895a88d10f17af8fb1017e6a37',
    gemviewer: 'https://hodltoken.net/gem-fighter-nfts/viewer',
    gemfighternftsnftscan: 'https://bnb.nftscan.com/0x1dc59c50d21514895a88d10f17af8fb1017e6a37?module=NFTs',
    gfraritypack: 'https://hodltoken.net/gem-fighter-nfts-guide.pdf',
    github: 'https://github.com/HODL-org',
    hodlchart: 'https://dexscreener.com/bsc/0xc5c4f99423dfd4d2b73d863aee50750468e45c19',
    hodlhandscontract: 'https://bscscan.com/token/0x7E82123bCb6465133D6E9E1Ad94d0115DE041b3D',
    hodlhandsdeck: 'https://hodltoken.net/nft-deck',
    hodlhandsnfts: 'https://hodltoken.net/hodl-hands-nfts',
    hodlhandsoverview: 'https://hodltoken.net/nft-overview',
    hhmarketplace: 'https://magiceden.io/collections/bsc/0x7e82123bcb6465133d6e9e1ad94d0115de041b3d',
    hhmarketplace2: 'https://element.market/collections/hodl-hands-nfts',
    instagram: 'https://instagram.com/hodltoken',
    investordeck: 'https://hodltoken.net/deck',
    kick: 'https://kick.com/gemfighter',
    kyc: 'https://github.com/coinscope-co/kyc/blob/main/hodl/kyc.png',
    linkedin: 'https://www.linkedin.com/company/hodl',
    linktree: 'https://linktr.ee/hodltoken',
    medium: 'https://medium.com/@HODL-token',
    merchandise: 'https://hodlstore.io',
    migration: 'https://hodltoken.net/resources/hodl-contract-history',
    nftmintlivetwitter: 'https://x.com/HODL_Hands_Live',
    nftrade: 'https://nftrade.com/assets/bsc/0x7e82123bcb6465133d6e9e1ad94d0115de041b3d',
    nftscan: 'https://bnb.nftscan.com/0x7e82123bcb6465133d6e9e1ad94d0115de041b3d?module=NFTs',
    nftsonhodlx: 'https://hodlx.exchange/nft-pools',
    nftvideos: 'https://www.youtube.com/watch?v=a8sbIk-qKog&list=PLh50Cy8l4VJJpLxsPODlRcOOCSNc9RZYP',
    nomics: 'https://nomics.com/assets/hodlx2-hodlx',
    OurTeam: '/about#our-team',
    overviewpdf: 'https://hodltoken.net/PDF',
    partnerprogramme: 'https://hodltoken.net/news/hodl-reward-partner-programme',
    playtoearnpr: 'https://finance.yahoo.com/news/dive-play-earn-games-earn-220500056.html',
    playtoearnvideo: 'https://hodltoken.net/videos/play-to-earn-gaming-coming-to-hodl',
    promotionalmaterials: 'https://hodltoken.net/promo-kit',
    rareboard: 'https://www.rareboard.com/hodl-hands',
    raritypack: 'https://hodl-assets.fly.dev/s/e738a5cb-952a-40be-a4a8-7e9bf86406de',
    reddit: 'https://reddit.com/r/HodlToken',
    refinable: 'https://hodl.refinable.store/',
    rewardstacking: 'https://hodltoken.net/stacking',
    risks: 'https://hodltoken.net/cryptocurrency-investment-risks',
    rugfreecoinsauditforhodl: 'https://github.com/Rugfreecoins/Smart-Contract-Audits/blob/main/HODL%20Token%20Audit%20.pdf',
    snapchat: 'https://www.snapchat.com/add/HodlToken',
    socialresources: 'https://hodltoken.net/resources/spread-the-word-about-hodl',
    stacking: 'https://hodltoken.net/stacking',
    stakehodl: 'https://hodlx.exchange/pools',
    stakenfts: 'https://hodlx.exchange/nft-pools',
    staketoearnnfts: 'https://hodlx.exchange/earn',
    telegram: 'https://t.me/hodlinvestorgroup',
    telegramForward: 'https://t.me/HodlForward',
    telegramapp: 'https://t.me/+7eDTngCs9RM4YTc0',
    threads: 'https://www.threads.net/@hodltoken',
    timeline: 'https://hodltoken.net/timeline',
    tofunft: 'https://tofunft.com/collection/hodl-hands/items',
    twitch: 'https://www.twitch.tv/gemfighterp2e',
    X: 'https://x.com/HODL_Official',
    twitter: 'https://x.com/HODL_Official',
    xhodlhands: 'https://x.com/HODLHandsNFT',
    xgemfighterlive: 'https://x.com/GemFighterMints',
    twitterhodlhandslive: 'https://x.com/HODL_Hands_Live',
    unicrypt: 'https://app.uncx.network/lockers/univ2/chain/56/address/0xc5c4f99423dfd4d2b73d863aee50750468e45c19',
    voteforhodl: 'https://linktr.ee/vote_hodl',
    vulkania: 'https://vulkania.io/coins/hodl',
    whatisstaking: 'https://www.coinbase.com/learn/crypto-basics/what-is-staking',
    whatisfarming: 'https://academy.binance.com/en/articles/what-is-yield-farming-in-decentralized-finance-defi',
    whatisimpermanentloss: 'https://hodltoken.net/resources/impermanent-loss-understanding-the-risks-and-rewards-of-liquidity-provision-in-decentralized-exchanges',
    yahoo: 'https://finance.yahoo.com/news/celebrating-three-years-hodl-pioneering-180600056.html',
    youtube: 'https://www.youtube.com/c/HODL-Official',
    youtubecommunity: 'https://www.youtube.com/@HODL-Official/community',
    youtubeapp: 'https://youtube.com/playlist?list=PLh50Cy8l4VJLFp8aFGodxtNXhrlpyVY4k&si=SrHIxX1OrD4uoBmK',
    youtubehub: 'https://www.youtube.com/watch?v=FIU-kGxFXu4&list=PLh50Cy8l4VJJcs8xgaXCg6sFYarRuYqAp',
    youtubenfts: 'https://www.youtube.com/watch?v=vJAOPfhGiv4&list=PLh50Cy8l4VJJpLxsPODlRcOOCSNc9RZYP',
    hodlverseinc: 'https://bestiejs.github.io/platform.js/',
    dashboard: '/dashboard',
    dashboardaddresses: '/dashboard/addresses',
    dashboardhodlers: '/dashboard/hodlers',
    dashboardreflections: '/dashboard/reflections',
    dashboardreinvestments: '/dashboard/reinvestments',
    dashboardrewards: '/dashboard/rewards',
    dashboardtransactions: '/dashboard/transactions'
  },
  navigation: [
    {
      identifier: 'key-info',
      name: 'Key Info',
      columns: [
        {
          name: 'DEFI’S ULTIMATE REWARDS ECOSYSTEM',
          links: [
            {
              url: '/about',
              label: 'About',
              description: '{WORLD} The HODL Ecosystem & How It Works',
              quicklink: false
            },
            {
              url: '/whitepaper',
              label: 'Whitepaper',
              description: '{DOCUMENT} The Blueprint for Innovation & Tokenomics',
              quicklink: false
            },
            {
              url: '/roadmap',
              label: 'Roadmap',
              description: '{COMPASS} Huge Milestones Delivered, Big Plans Ahead',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: 'https://hodltoken.net/achievements',
              label: 'Achievements',
              description: '{BIONIC_ARM} Dominating DeFi Since May 2021',
              quicklink: false
            },
            {
              url: 'https://hodltoken.net/deck',
              label: 'Deck',
              description: '{DOWNLOAD} Download the HODL Investor Deck (PDF)',
              quicklink: false
            },
            {
              url: '/about#our-team',
              label: 'Team',
              description: '{TEAM} Doxxed Leadership with a Proven Track Record',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: '/security',
              label: 'Security',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodltoken.net/timeline',
              label: 'Timeline',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: '$hodl',
      name: '$HODL',
      columns: [
        {
          name: 'THE MOST REWARDING TOKEN IN DEFI',
          links: [
            {
              url: 'https://hodltoken.net/about-our-token',
              label: 'How Rewards Work',
              description: '{KING} The King of BNB Rewards',
              quicklink: false
            },
            {
              url: 'https://pancakeswap.finance/swap?outputCurrency=0x32b407ee915432be6d3f168bc1eff2a6f8b2034c',
              label: 'Buy $HODL »',
              description: '{ORANGE_DIAMOND} Hold & Earn BNB on Repeat (Slippage: 6%)',
              quicklink: false
            },
            {
              url: '/exchanges',
              label: 'Exchanges',
              description: '{BUY} Get In Now – DEX Listings & Info',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: 'https://hodltoken.net/#calculator',
              label: 'Calculator',
              description: '{CALCULATOR} See What Rewards You’ll Earn Inc. APR',
              quicklink: false
            },
            {
              url: 'https://dexscreener.com/bsc/0xc5c4f99423dfd4d2b73d863aee50750468e45c19',
              label: 'Chart »',
              description: '{CHART} Track HODL’s Growth Live on DEX Screener',
              quicklink: false
            },
            {
              url: '/dashboard',
              label: 'Dashboard',
              description: '{DASHBOARD} Track Your Investment Performance & Key Info',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: 'https://hodltoken.net/claim',
              label: 'Claim Rewards',
              description: '',
              quicklink: true
            },
            {
              url: 'https://bscscan.com/token/0x32b407ee915432be6d3f168bc1eff2a6f8b2034c',
              label: 'BscScan Contract »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://github.com/cyberscope-io/audits/blob/main/hodl/audit.pdf',
              label: 'Audit Report »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://app.uncx.network/lockers/univ2/chain/56/address/0xc5c4f99423dfd4d2b73d863aee50750468e45c19',
              label: 'Liquidity Lock »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://github.com/coinscope-co/kyc/blob/main/hodl/kyc.png',
              label: 'Doxxed & KYC Verified »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodltoken.net/resources/hodl-contract-history',
              label: 'Migration »',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: 'gem-fighter',
      name: 'Gem Fighter',
      columns: [
        {
          name: 'PLAY GEM FIGHTER — EARN $HODL',
          links: [
            {
              url: 'https://hodltoken.net/gem-fighter-p2e',
              label: 'About',
              description: '{WORLD} Explore the Gem Fighter Universe & Earn',
              quicklink: false
            },
            {
              url: 'https://store.epicgames.com/en-US/p/gem-fighter-c706ec',
              label: 'Play on Epic »',
              description: '{GAMING} Available to 300M+ Players on Epic Games',
              quicklink: false
            },
            {
              url: 'https://gemfighter.game',
              label: 'GemFighter.game »',
              description: '{APP} Visit the Official Gem Fighter Website',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: '/gem-fighter-nfts',
              label: 'Gem Fighter NFTs',
              description: '{GEM} Battle. Win. Earn $HODL.',
              quicklink: false
            },
            {
              url: 'https://hodltoken.net/videos/gem-fighter-cinematic-story-trailer',
              label: 'Trailer',
              description: '{VIDEOS} Enter the Cinematic World of Gem Fighter',
              quicklink: false
            },
            {
              url: 'https://gemfighter.game/leaderboard',
              label: 'Leaderboard »',
              description: '{EARN} Track the Top $HODL Earners This Month',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: 'https://www.twitch.tv/gemfighterp2e',
              label: 'Twitch »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://kick.com/gemfighter',
              label: 'Kick »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://x.com/GemFighterP2E',
              label: 'Follow on X »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://magiceden.io/collections/bsc/0x1dc59c50d21514895a88d10f17af8fb1017e6a37',
              label: 'Trade on Magic Eden »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://element.market/collections/gem-fighter-nfts',
              label: 'Trade on Element »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodlx.exchange/nft-pools',
              label: 'Stake Gem Fighter NFTs »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodlx.exchange/nft-pools',
              label: 'Buy NFTs with $HODL & Save »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodltoken.net/gem-fighter-nfts/viewer',
              label: '3D Gem Viewer',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: 'hodl-hands®',
      name: 'HODL Hands®',
      columns: [
        {
          name: 'ICONIC NFT ART. REAL $HODL REWARDS.',
          links: [
            {
              url: '/hodl-hands-nfts',
              label: 'About',
              description: '{HODL_HANDS} A Symbol of Strength, Unity & Resistance',
              quicklink: false
            },
            {
              url: 'https://hodlx.exchange/nft-pools',
              label: 'Buy With $HODL & Save »',
              description: '{ORANGE_DIAMOND} Get HODL Hands® at a Discount',
              quicklink: false
            },
            {
              url: 'https://hodlx.exchange/nft-pools',
              label: 'Staking Pools »',
              description: '{EARN} Earn $HODL by Holding & Staking Your NFTs',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: 'https://www.rareboard.com/hodl-hands',
              label: 'Rareboard »',
              description: '{BUY} Trade HODL Hands® on Rareboard',
              quicklink: false
            },
            {
              url: 'https://magiceden.io/collections/bsc/0x7e82123bcb6465133d6e9e1ad94d0115de041b3d',
              label: 'Magic Eden »',
              description: '{BUY} Trade HODL Hands® on Magic Eden',
              quicklink: false
            },
            {
              url: 'https://element.market/collections/hodl-hands-nfts',
              label: 'Element »',
              description: '{BUY} Trade HODL Hands® on Element Marketplace',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: 'https://x.com/HODLHandsNFT',
              label: 'Follow on X »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://bscscan.com/token/0x7E82123bCb6465133D6E9E1Ad94d0115DE041b3D',
              label: 'Contract (BscScan) »',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: 'app',
      name: 'App',
      columns: [
        {
          name: 'ONE APP – EVERYTHING HODL',
          links: [
            {
              url: 'app',
              label: 'About',
              description: '{APP} Our Entire Earnings Ecosystem in One App',
              quicklink: false
            },
            {
              url: 'https://hodltoken.net/apple-app',
              label: 'iOS App »',
              description: '{APPLE} Free to download via the App Store',
              quicklink: false
            },
            {
              label: 'Android App »',
              description: '{ANDROID} Coming Soon to the Play Store',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: 'basic-app-user-guide',
              label: 'Lite Mode',
              description: '{LITE} Fast, Simple & Built for Beginners',
              quicklink: false
            },
            {
              url: 'pro-app-user-guide',
              label: 'Pro Mode',
              description: '{PRO} Advanced Tools to Maximize Profits',
              quicklink: false
            },
            {
              url: 'https://hodltoken.net/app#security',
              label: 'Security',
              description: '{SECURE} Military-Grade Protection for Your $HODL',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: 'https://t.me/+7eDTngCs9RM4YTc0',
              label: 'App Support »',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: 'community',
      name: 'Community',
      columns: [
        {
          name: 'BECOME A HODLER',
          links: [
            {
              url: 'https://t.me/hodlinvestorgroup',
              label: 'Telegram »',
              description: '{CHAT} Join the Conversation with the Community',
              quicklink: false
            },
            {
              url: 'https://x.com/HODL_Official',
              label: 'X »',
              description: '{X} Non-Stop Updates, Insights & News',
              quicklink: false
            },
            {
              url: 'https://www.binance.com/en/square/profile/hodl_official',
              label: 'Binance Square »',
              description: '{BINANCE_SQUARE} Join the Community on BNB\'s Binance Square',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: 'https://reddit.com/r/HodlToken',
              label: 'Reddit »',
              description: '{REDDIT} Stay Up to Date & Discuss HODL',
              quicklink: false
            },
            {
              url: '/case-studies',
              label: 'Case Studies',
              description: '{CASE_STUDIES} Real People, Real Profits, Real Success',
              quicklink: false
            },
            {
              url: '/charity',
              label: 'Charity',
              description: '{CHARITY} Making an Impact with the HODL Revolution',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: 'https://discord.com/invite/D666jh5C5D',
              label: 'Discord »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://facebook.com/HODLtokenBSC',
              label: 'Facebook »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://instagram.com/hodltoken',
              label: 'Instagram »',
              description: '',
              quicklink: true
            },
            {
              url: 'https://www.linkedin.com/company/hodl',
              label: 'LinkedIn »',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    },
    {
      identifier: 'resources',
      name: 'Resources',
      columns: [
        {
          name: 'EXPLORE MORE ABOUT HODL',
          links: [
            {
              url: '/news',
              label: 'News',
              description: '{NEWS} Breaking Updates from the HODL Ecosystem',
              quicklink: false
            },
            {
              url: '/faqs',
              label: 'FAQs',
              description: '{FAQS} The Quickest Way to Get Answers',
              quicklink: false
            },
            {
              url: 'https://hodlstore.io',
              label: 'Shop »',
              description: '{MERCH} Rep the Brand & Show Your HODL Status',
              quicklink: false
            }
          ]
        },
        {
          name: '',
          links: [
            {
              url: '/partners',
              label: 'Partners',
              description: '{PARTNERS} Meet the Key Players Behind HODL’s Success',
              quicklink: false
            },
            {
              url: '/history-of-hodl',
              label: 'HODL Origin',
              description: '{ORIGIN} The Story Behind the Biggest Crypto Movement',
              quicklink: false
            },
            {
              url: '/videos',
              label: 'Videos',
              description: '{VIDEOS} Watch, Learn & Get Ahead',
              quicklink: false
            }
          ]
        },
        {
          name: 'Useful Links',
          links: [
            {
              url: '/resources',
              label: 'Resource Library',
              description: '',
              quicklink: true
            },
            {
              url: 'https://hodltoken.net/promo-kit',
              label: 'Media Kit',
              description: '',
              quicklink: true
            },
            {
              url: '/ranks',
              label: 'Investor Ranks',
              description: '',
              quicklink: true
            }
          ]
        }
      ]
    }
  ],
  pages: {
    index: '/',
    aboutUs: '/about',
    app: '/app',
    caseStudies: '/case-studies',
    claim: '/claim',
    news: '/news',
    events: '/events',
    resourceLibrary: '/resources',
    exchanges: '/exchanges',
    faqs: '/faqs',
    fundraising: '/fundraising',
    gemFighternfts: '/gem-fighter-nfts',
    gemFighterP2E: '/gem-fighter-p2e',
    history: '/history-of-hodl',
    hodlxExchanges: '/hodlx-exchanges',
    hodlForward: '/charity',
    hodlRanks: '/ranks',
    nfts: '/hodl-hands-nfts',
    ourPartners: '/partners',
    roadmap: '/roadmap',
    termsOfUse: '/terms',
    hodlCoins: '/first-edition-coins',
    cookies: '/cookies',
    disclaimers: '/disclaimers',
    privacy: '/privacy',
    communityrules: '/community-guidelines',
    bugBounty: '/bug-bounty',
    achievements: '/achievements',
    abouthodl: '/about-our-token',
    security: '/security',
    timeline: '/timeline',
    appBasicUserGuide: 'basic-app-user-guide',
    proAppUserGuide: 'pro-app-user-guide',
    aboutApp: 'app',
    bitmart: 'bitmart-recovery',
    videos: '/videos',
    whitepaper: '/whitepaper',
    dashboard: '/dashboard',
    dashboardAddresses: '/dashboard/addresses',
    dashboardHodlers: '/dashboard/hodlers',
    dashboardReflections: '/dashboard/reflections',
    dashboardReinvestments: '/dashboard/reinvestments',
    dashboardRewards: '/dashboard/rewards',
    dashboardTransactions: '/dashboard/transactions'
  },
  projectFunds: '0x30CaF94164160d431338dF15aEDD11Fc9025ac33 - Investment wallet\n0x9b8f934beb96f2e5ddaad90a25adecf86017a0d1 - Deployer\n0xC3f41653168501B1A0c489bf1be0D6a054E34C1A - HODL Hands owner wallet\n0x0a199377F5489A285c70f03326b6D4BF769c10d3 - Marketing wallet\n0xc18406dd23aa13a06387c84f377f01cc5c187115 - Crypto.com card payment wallet\n0x02e4097a6710a45c13367dc067fad6b6d9d6b9d5 - HODL Store wallet\n0x1Be2bf839a71Fd30d2eadd324bDF959c1Bb0235B - Exchange Team\n0x894606f1eea0e37f5537a190da291b855fe685b1 - Company wallet'
};
export default variables;